var map = {
	"./404.svg": 65597,
	"./OCP.svg": 28631,
	"./application-service-management.svg": 15255,
	"./application.svg": 87068,
	"./attachment.svg": 14677,
	"./book.svg": 15480,
	"./calendar.svg": 7698,
	"./checked.svg": 60489,
	"./circulate.svg": 84301,
	"./cloud.svg": 31719,
	"./colApplication.svg": 94919,
	"./collection.svg": 87066,
	"./collectioned.svg": 6211,
	"./copy.svg": 85282,
	"./department.svg": 27020,
	"./dot.svg": 41917,
	"./download.svg": 26419,
	"./english.svg": 71622,
	"./erCode.svg": 22381,
	"./favorite.svg": 45539,
	"./file.svg": 86394,
	"./flow-instance.svg": 17074,
	"./fullscreen-scale.svg": 15054,
	"./fullscreen.svg": 74440,
	"./grade.svg": 97266,
	"./guide.svg": 59693,
	"./handled.svg": 72888,
	"./heart.svg": 38509,
	"./help.svg": 42747,
	"./initiate.svg": 8011,
	"./jxsfHome.svg": 2855,
	"./localtion.svg": 32524,
	"./localtionBlack.svg": 48138,
	"./mail-index.svg": 77037,
	"./mail.svg": 39562,
	"./message-index.svg": 10369,
	"./message-service.svg": 47545,
	"./message.svg": 42176,
	"./news.svg": 64265,
	"./noDataIcon.svg": 54936,
	"./paper.svg": 28617,
	"./personaldata.svg": 29359,
	"./post-management.svg": 41658,
	"./recApplication.svg": 33011,
	"./recall.svg": 30178,
	"./recentlyUsed.svg": 61405,
	"./salay.svg": 49063,
	"./schedule.svg": 86763,
	"./seal.svg": 29020,
	"./service.svg": 54508,
	"./shield.svg": 76443,
	"./skdCollection.svg": 47792,
	"./skdecard.svg": 51854,
	"./skdmail.svg": 95168,
	"./skin.svg": 70464,
	"./squre.svg": 1974,
	"./su-icon-offline.svg": 58717,
	"./su-icon-online.svg": 57143,
	"./sun.svg": 54829,
	"./task-view.svg": 31689,
	"./telephone.svg": 93356,
	"./thunder.svg": 98251,
	"./time copy.svg": 62503,
	"./time.svg": 11158,
	"./timeBlack.svg": 66021,
	"./todo-index.svg": 58131,
	"./todo.svg": 72188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;